import React from "react";
import { Row, Col, Card, Input, Modal } from "antd";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import data from "../../../../constants/retailPos.json";

const SalesRepresentativeModal = ({
  salesRepModalOpen,
  setSalesRepModalOpen,
  salesRepModalInputRef,
  salesRepresentSearchInput,
  setSalesRepresentSearchInput,
  handleSalesRepresentSearchInput,
  filteredSalesRepresentList,
  handleSalesRepresentive,
}) => {
  return (
    <Modal open={salesRepModalOpen.status} closable={false} footer={null} keyboard={false} styles={{ body: { padding: "20px 15px 15px" } }}>
      <Row>
        <Col span={7}>
          <ArrowLeftOutlined
            style={data.posScreenStyles.orderHistoryModal.backArrowIcon}
            onClick={() => {
              setSalesRepModalOpen({ status: false, title: "" });
              setSalesRepresentSearchInput("");
            }}
          />
        </Col>
        <Col span={17}>
          <p style={data.posScreenStyles.parkedBillModal.parkedBillsHistoryModalTitle}>Sales Representative</p>
        </Col>
      </Row>
      <Row style={{ paddingBottom: "12px" }}>
        <Col span={24}>
          <Input
            ref={salesRepModalInputRef}
            placeholder={`Sales Representative Search`}
            size="large"
            allowClear={false}
            style={data.posScreenStyles.orderHistoryModal.orderHistorySearchInput}
            onChange={(e) => handleSalesRepresentSearchInput(e.target.value)}
            value={salesRepresentSearchInput}
            suffix={<SearchOutlined style={data.posScreenStyles.customerModal.searchIcon} />}
          />
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        {filteredSalesRepresentList.map((item, index) => (
          <Col span={8} key={`${item.name}-${index}`}>
            <Card
              tabIndex={0}
              styles={{ body: { padding: "12px" } }}
              className="salesRepresentativeCard focusDashboardCard"
              onClick={() => handleSalesRepresentive(item)}
              onKeyPress={(e) => (e.charCode === 13 ? handleSalesRepresentive(item) : null)}
            >
              <p className="representativeName">{item.name}</p>
            </Card>
          </Col>
        ))}
        <Col span={8}>
          <Card
            tabIndex={0}
            styles={{ body: { padding: "12px" } }}
            key={`none-key`}
            className="salesRepresentativeCard focusDashboardCard"
            onClick={() => handleSalesRepresentive({ salesRepresentId: null, name: null })}
            onKeyPress={(e) =>
              e.charCode === 13
                ? handleSalesRepresentive({
                    salesRepresentId: null,
                    name: null,
                  })
                : null
            }
          >
            <p className="representativeName">None</p>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export default SalesRepresentativeModal;
